import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vac-message-file-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "vac-image-buttons"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import { computed, ref } from "vue";
import { CardMessage, MessageFile, TextFormatting } from "vue-advanced-chat";
import FormatMessage from "vue-advanced-chat/src/components/FormatMessage/FormatMessage.vue";
import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";

type FilePayload = { file: MessageFile; action: string };
// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    content: null,
    files: null,
    roomUsers: null,
    textFormatting: { default: () => ({
			disabled: false,
			italic: "_",
			bold: "*",
			strike: "~",
			underline: "°",
			multilineCode: "```",
			inlineCode: "`",
		}) },
    linkOptions: { default: () => ({ disabled: false, target: "_blank", rel: null }) }
  },
  emits: ["open-file", "download-file"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "open-file", payload: FilePayload): void;
	(e: "download-file", payload: FilePayload): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { content: string, files: CardMessage[], roomUsers: unknown[], textFormatting: TextFormatting, linkOptions: {
			disabled: false;
			target: string;
			rel: unknown;
		} }





const imageHover = ref(false);

const formattedMessage = computed<
	{ content: string; attachment?: MessageFile }[]
>(() => {
	const strs = props.content.split(/(\[[\w:\s.]+\])/).filter(t => !!t);
	const format = [];
	for (let i = 0; i < strs.length; i++) {
		const nameFile = strs[i]?.match(/(?:\[)(?:\w+:\s)(.*)(?=\])/)?.[1] ?? "";
		format.push({
			content: !nameFile ? strs?.[i] : "",
			attachment: nameFile
				? {
						type: nameFile.split(".")[1],
						url: props.files.find(file => file.title === nameFile)?.image ?? "",
						name: nameFile,
				}
				: undefined,
		});
	}
	return format;
});
function openFile(
	event: Event,
	{ action, file }: { action: string; file?: MessageFile }
) {
	event.stopPropagation();
	if (file) emits("open-file", { action, file });
}
function downloadFile(
	event: Event,
	{ action, file }: { action: string; file?: MessageFile }
) {
	event.stopPropagation();
	if (file) emits("download-file", { action, file });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formattedMessage), (file, idx) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: idx + 'iv'
      }, [
        (file.attachment)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vac-message-image-container",
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (imageHover.value = true)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (imageHover.value = false)),
              onClick: ($event: any) => (
					openFile($event, {
						file: file.attachment,
						action: 'preview',
					})
				)
            }, [
              (file.content)
                ? (_openBlock(), _createBlock(FormatMessage, {
                    key: 0,
                    content: file.content,
                    users: __props.roomUsers,
                    "text-formatting": __props.textFormatting,
                    "link-options": __props.linkOptions
                  }, _createSlots({ _: 2 }, [
                    _renderList(_ctx.$slots, (i, name) => {
                      return {
                        name: name,
                        fn: _withCtx((data) => [
                          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                        ])
                      }
                    })
                  ]), 1032, ["content", "users", "text-formatting", "link-options"]))
                : _createCommentVNode("", true),
              (file.attachment)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "vac-message-image",
                    style: _normalizeStyle({
						'background-image': `url('${file.attachment.url}')`,
					})
                  }, [
                    _createVNode(_Transition, { name: "vac-fade-image" }, {
                      default: _withCtx(() => [
                        (imageHover.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createElementVNode("div", {
                                class: "vac-svg-button vac-button-view",
                                onClick: ($event: any) => (
									openFile($event, {
										file: file.attachment,
										action: 'preview',
									})
								)
                              }, [
                                _renderSlot(_ctx.$slots, "eye-icon", {}, () => [
                                  _createVNode(SvgIcon, { name: "eye" })
                                ])
                              ], 8, _hoisted_4),
                              _createElementVNode("div", {
                                class: "vac-svg-button vac-button-download",
                                onClick: ($event: any) => (
									downloadFile($event, {
										file: file.attachment,
										action: 'download',
									})
								)
                              }, [
                                _renderSlot(_ctx.$slots, "document-icon", {}, () => [
                                  _createVNode(SvgIcon, { name: "document" })
                                ])
                              ], 8, _hoisted_5)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ], 4))
                : _createCommentVNode("", true)
            ], 40, _hoisted_2))
          : (_openBlock(), _createBlock(FormatMessage, {
              key: 1,
              content: file.content,
              users: __props.roomUsers,
              "text-formatting": __props.textFormatting,
              "link-options": __props.linkOptions
            }, _createSlots({ _: 2 }, [
              _renderList(_ctx.$slots, (i, name) => {
                return {
                  name: name,
                  fn: _withCtx((data) => [
                    _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                  ])
                }
              })
            ]), 1032, ["content", "users", "text-formatting", "link-options"]))
      ], 64))
    }), 128))
  ]))
}
}

})